<template>
  <el-select
    v-model="input"

    placeholder="Enter name of Account Type"
    :remote-method="querySearch"
    :trigger-on-focus="false"
    multiple
    filterable
    remote
    class="w-100"
    placement="top"
    clearable
    :loading="isLoading"
    value-key="id"
  >
    <el-option
      v-for="(item,index) in data"
      :key="index"
      :label="item.desc"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {

  data () {
    return {
      input: '',
      isLoading: false,
      data: []
    }
  },
  methods: {
    querySearch (queryString) {
      this.isLoading = true
      this.$sdk.dictionary_acctype.list(builder => {
        builder.filters = { acctype_tag: queryString }
      }).then(res => {
        this.data = res
        this.isLoading = false
      })
    },
    getAcctypeList () {
      return this.input
    }
  }
}
</script>

<style>

</style>
